module.exports = __webpack_public_path__ + "static/media/sparq1.209d541b.jpg";